import React, { useState } from "react";
import PropTypes from "prop-types";

import { Column, Field, Control, Label, Input } from "rbx";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = {};

function GroupFilters({ filters, onFilter, onClose }) {
  const [inputs, setInputs] = useState({ ...filters });
  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field>
            <Control>
              <Label>Group Id</Label>
              <Input
                name="GroupId_contains"
                type="text"
                value={inputs.GroupId_contains}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
GroupFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default GroupFilters;
